(function () {
  var SECTION_SELECTOR = '[data-cd-home-specs]';
  var MOBILE_QUERY = '(max-width: 767px)';

  function initSection(section) {
    if (!section || section.dataset.cdHomeSpecsReady === 'true') return;

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-cd-specs-item]'));
    var list = section.querySelector('[data-cd-specs-list]');
    var previousButton = section.querySelector('[data-cd-specs-mobile-prev]');
    var nextButton = section.querySelector('[data-cd-specs-mobile-next]');
    var closeButton = section.querySelector('[data-cd-specs-mobile-close]');
    var stage = section.querySelector('.cd-home-specs__stage');
    var media = section.querySelector('.cd-home-specs__media');
    var mainImage = section.querySelector('.cd-home-specs__image');
    var placeholder = section.querySelector('.cd-home-specs__placeholder');
    var swatches = Array.prototype.slice.call(section.querySelectorAll('[data-cd-specs-swatch]'));
    var mobileTriggers = Array.prototype.slice.call(section.querySelectorAll('[data-cd-specs-mobile-trigger]'));
    var mobileQuery = window.matchMedia(MOBILE_QUERY);
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var activeMobileIndex = Math.max(0, items.findIndex(function (item) {
      return item.classList.contains('is-mobile-active');
    }));
    var touchStartX = null;
    var touchStartY = null;
    var touchStartTime = 0;
    var touchAxis = null;
    var touchDidMove = false;
    var suppressClickUntil = 0;
    var imageSwapToken = 0;
    var imageLayers = [];
    var currentImageLayer = null;
    var currentImageUrl = '';
    var requestedImageUrl = '';
    var imageAnimations = [];
    var activeImageFinalize = null;
    var mobileMorphToken = 0;
    var mobileAnimations = [];
    var mobileMorphCleanups = [];
    var mobileMorphItem = null;
    var mobileTransitionLocked = false;
    var pendingMobileNavigation = 0;
    var activeMobileNavFinalize = null;

    if (!items.length) return;
    section.dataset.cdHomeSpecsReady = 'true';

    function panelFor(item) {
      return item ? item.querySelector('[data-cd-specs-panel]') : null;
    }

    function toggleFor(item) {
      return item ? item.querySelector('[data-cd-specs-toggle]') : null;
    }

    function setExpandedHeight(item, panel) {
      if (!item || !panel) return 160;
      var inner = panel.querySelector('.cd-home-specs__panel-inner');
      panel.hidden = false;
      item.classList.add('is-measuring');
      var expandedHeight = Math.max(160, Math.ceil((inner && inner.scrollHeight) || panel.scrollHeight || 160));
      item.classList.remove('is-measuring');
      item.style.setProperty('--cd-spec-expanded-height', expandedHeight + 'px');
      return expandedHeight;
    }

    function finishClosed(item, panel) {
      if (item.classList.contains('is-open')) return;
      item.classList.remove('is-closing');
      panel.hidden = true;
    }

    function closeItem(item, immediate) {
      var panel = panelFor(item);
      var toggle = toggleFor(item);
      if (!panel || !item.classList.contains('is-open')) return;

      if (toggle) toggle.setAttribute('aria-expanded', 'false');

      if (immediate) {
        item.classList.remove('is-open');
        item.classList.remove('is-closing');
        panel.hidden = true;
        return;
      }

      panel.hidden = false;
      item.classList.add('is-closing');
      item.classList.remove('is-open');
      item.addEventListener('transitionend', function onClosed(event) {
        if (event.propertyName !== 'height') return;
        item.removeEventListener('transitionend', onClosed);
        finishClosed(item, panel);
      });
    }

    function openItem(item, immediate) {
      var panel = panelFor(item);
      var toggle = toggleFor(item);
      if (!panel) return;

      items.forEach(function (candidate) {
        if (candidate !== item) closeItem(candidate, immediate);
      });

      changeItemBackground(item, immediate);

      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      item.classList.remove('is-closing');
      panel.hidden = false;
      setExpandedHeight(item, panel);

      if (immediate) {
        item.classList.add('is-open');
        return;
      }

      item.classList.remove('is-open');
      item.offsetHeight;
      item.classList.add('is-open');
    }

    function activeMobileItem() {
      return items[activeMobileIndex] || items[0];
    }

    function mobileTriggerFor(item) {
      return item ? item.querySelector('[data-cd-specs-mobile-trigger]') : null;
    }

    function mobileCardFor(item) {
      return item ? item.querySelector('[data-cd-specs-mobile-card]') : null;
    }

    var chipMeasureCanvas = document.createElement('canvas');
    var chipMeasureContext = chipMeasureCanvas.getContext('2d');

    function numericStyle(value) {
      var number = parseFloat(value);
      return Number.isFinite(number) ? number : 0;
    }

    function textIntrinsicWidth(element) {
      if (!element) return 0;

      var text = (element.textContent || '').trim();
      if (!text) return 0;

      // scrollWidth is the most accurate option when the control is currently
      // rendered. The canvas fallback also works for inactive mobile chips whose
      // parent is display:none.
      var renderedWidth = Math.max(element.scrollWidth || 0, element.getBoundingClientRect().width || 0);
      if (renderedWidth > 0) return renderedWidth;

      if (!chipMeasureContext) return text.length * 8;
      var styles = window.getComputedStyle(element);
      var fontParts = [
        styles.fontStyle,
        styles.fontVariant,
        styles.fontWeight,
        styles.fontSize,
        styles.fontFamily
      ].filter(Boolean);
      chipMeasureContext.font = fontParts.join(' ');

      var measuredWidth = chipMeasureContext.measureText(text).width;
      var letterSpacing = numericStyle(styles.letterSpacing);
      if (letterSpacing && text.length > 1) measuredWidth += letterSpacing * (text.length - 1);
      return measuredWidth;
    }

    function controlIntrinsicWidth(control, title, icon, fallbackGap) {
      if (!control || !title) return 0;
      var styles = window.getComputedStyle(control);
      var iconStyles = icon ? window.getComputedStyle(icon) : null;
      var gap = numericStyle(styles.columnGap || styles.gap) || fallbackGap || 0;
      var iconWidth = iconStyles ? numericStyle(iconStyles.width) : 0;

      return Math.ceil(
        numericStyle(styles.paddingLeft) +
        numericStyle(styles.paddingRight) +
        iconWidth +
        gap +
        textIntrinsicWidth(title) +
        2
      );
    }

    function measureChipWidths() {
      items.forEach(function (item) {
        var desktopControl = toggleFor(item);
        var desktopTitle = desktopControl ? desktopControl.querySelector('.cd-home-specs__summary-title') : null;
        var desktopIcon = desktopControl ? desktopControl.querySelector('.cd-home-specs__summary-icon') : null;
        var desktopWidth = controlIntrinsicWidth(desktopControl, desktopTitle, desktopIcon, 10);
        if (desktopWidth) {
          item.style.setProperty('--cd-spec-chip-width-desktop', Math.max(84, desktopWidth) + 'px');
        }

        // Mobile-only rules define the mobile trigger's padding, icon and font.
        // Measure them only while that media query is active, then keep the value
        // available for every open/close morph.
        if (mobileQuery.matches) {
          var mobileControl = mobileTriggerFor(item);
          var mobileTitle = mobileControl ? mobileControl.querySelector('.cd-home-specs__mobile-trigger-title') : null;
          var mobileIcon = mobileControl ? mobileControl.querySelector('.cd-home-specs__mobile-trigger-icon') : null;
          var mobileWidth = controlIntrinsicWidth(mobileControl, mobileTitle, mobileIcon, 10);
          var mobileMaximum = Math.max(84, window.innerWidth - 40);
          if (mobileWidth) {
            item.style.setProperty('--cd-spec-chip-width-mobile', Math.min(mobileMaximum, Math.max(84, mobileWidth)) + 'px');
          }
        }
      });
    }

    function syncMobileChrome(expanded) {
      items.forEach(function (item, itemIndex) {
        var trigger = mobileTriggerFor(item);
        if (trigger) trigger.setAttribute('aria-expanded', expanded && itemIndex === activeMobileIndex ? 'true' : 'false');
      });
      if (closeButton) {
        closeButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        closeButton.setAttribute('aria-label', expanded ? 'Collapse specifications' : 'Open selected specification');
      }
    }

    function setMobileActive(index, immediate, updateBackground, direction) {
      activeMobileIndex = (index + items.length) % items.length;
      items.forEach(function (item, itemIndex) {
        item.classList.toggle('is-mobile-active', itemIndex === activeMobileIndex);
      });
      if (mobileQuery.matches && updateBackground !== false && !section.classList.contains('is-mobile-copy-closed')) {
        changeItemBackground(items[activeMobileIndex], immediate, direction);
      }
      syncMobileChrome(!section.classList.contains('is-mobile-copy-closed'));
    }

    function cancelMobileAnimations() {
      mobileAnimations.forEach(function (animation) {
        try { animation.cancel(); } catch (error) {}
      });
      mobileAnimations = [];

      var cleanups = mobileMorphCleanups.slice();
      mobileMorphCleanups = [];
      cleanups.forEach(function (cleanup) {
        try { cleanup(); } catch (error) {}
      });

      if (mobileMorphItem) mobileMorphItem.style.removeProperty('z-index');
      mobileMorphItem = null;
      section.classList.remove('is-mobile-morphing');
    }

    function removeInlineProperties(element, properties) {
      if (!element) return;
      properties.forEach(function (property) {
        element.style.removeProperty(property);
      });
    }

    function waitForAnimations(animations, callback) {
      Promise.all(animations.map(function (animation) {
        return animation.finished.catch(function () {});
      })).then(callback);
    }

    function flushPendingMobileNavigation() {
      if (
        !mobileQuery.matches ||
        mobileTransitionLocked ||
        section.classList.contains('is-mobile-copy-closed') ||
        pendingMobileNavigation === 0
      ) return;

      var direction = pendingMobileNavigation > 0 ? 1 : -1;
      pendingMobileNavigation -= direction;
      navigateMobile(direction, direction > 0 ? nextButton : previousButton, true);
    }

    function unlockMobileTransition() {
      mobileTransitionLocked = false;
      if (pendingMobileNavigation !== 0) {
        window.requestAnimationFrame(flushPendingMobileNavigation);
      }
    }

    function centerRailItem(item) {
      if (!list || !item) return;
      var target = item.offsetLeft + (item.offsetWidth / 2) - (list.clientWidth / 2);
      var maximum = Math.max(0, list.scrollWidth - list.clientWidth);
      list.scrollLeft = Math.max(0, Math.min(maximum, target));
    }

    function resetMobileStageScroll() {
      if (!stage || !mobileQuery.matches) return;
      // The arrows intentionally sit half outside the stage. Browsers can
      // programmatically scroll an overflow:hidden container when one of those
      // controls receives focus, shifting both arrows by 20px. Keep the stage
      // pinned to its visual origin as a fallback for engines without
      // `overflow: clip` support.
      if (stage.scrollLeft !== 0) stage.scrollLeft = 0;
      if (stage.scrollTop !== 0) stage.scrollTop = 0;
    }


    function pageCoordinates(rect) {
      var pageLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;
      var pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      return {
        left: rect.left + pageLeft,
        top: rect.top + pageTop,
        width: rect.width,
        height: rect.height
      };
    }

    function settledRect(rect, expanding) {
      var factor = expanding ? 1.006 : 0.994;
      var width = rect.width * factor;
      var height = rect.height * factor;
      return {
        left: rect.left - ((width - rect.width) / 2),
        top: rect.top - ((height - rect.height) / 2),
        width: width,
        height: height
      };
    }

    function shellGeometryKeyframes(startRect, endRect, startRadius, endRadius) {
      var start = pageCoordinates(startRect);
      var end = pageCoordinates(endRect);
      var settle = settledRect(end, (end.width * end.height) >= (start.width * start.height));

      return [
        {
          left: start.left + 'px',
          top: start.top + 'px',
          width: start.width + 'px',
          height: start.height + 'px',
          borderRadius: startRadius,
          offset: 0
        },
        {
          left: settle.left + 'px',
          top: settle.top + 'px',
          width: settle.width + 'px',
          height: settle.height + 'px',
          borderRadius: endRadius,
          offset: 0.88
        },
        {
          left: end.left + 'px',
          top: end.top + 'px',
          width: end.width + 'px',
          height: end.height + 'px',
          borderRadius: endRadius,
          offset: 1
        }
      ];
    }

    function cloneMobileCard(item, width, height) {
      var card = mobileCardFor(item);
      if (!card) return null;
      var clone = card.cloneNode(true);
      clone.removeAttribute('data-cd-specs-mobile-card');
      clone.classList.add('cd-home-specs__mobile-shell-card');
      clone.setAttribute('aria-hidden', 'true');
      clone.style.setProperty('width', width + 'px');
      clone.style.setProperty('height', height + 'px');
      clone.style.setProperty('min-height', height + 'px');
      clone.style.setProperty('transition', 'none');
      clone.querySelectorAll('button, a, input, select, textarea').forEach(function (control) {
        control.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    function cloneMobileChipContent(item, width, height) {
      var trigger = mobileTriggerFor(item);
      if (!trigger) return null;
      var content = document.createElement('div');
      content.className = 'cd-home-specs__mobile-shell-chip-content';
      content.setAttribute('aria-hidden', 'true');
      content.style.setProperty('width', width + 'px');
      content.style.setProperty('height', height + 'px');
      Array.prototype.slice.call(trigger.children).forEach(function (child) {
        content.appendChild(child.cloneNode(true));
      });
      return content;
    }

    function createChipCardMorph(item, startRect, endRect, opening, duration, easing) {
      var shell = document.createElement('div');
      var cardWidth = opening ? endRect.width : startRect.width;
      var cardHeight = opening ? endRect.height : startRect.height;
      var chipWidth = opening ? startRect.width : endRect.width;
      var chipHeight = opening ? startRect.height : endRect.height;
      var card = cloneMobileCard(item, cardWidth, cardHeight);
      var chip = cloneMobileChipContent(item, chipWidth, chipHeight);
      var start = pageCoordinates(startRect);
      var animations = [];

      shell.className = 'cd-home-specs__mobile-shell-morph';
      shell.setAttribute('aria-hidden', 'true');
      shell.style.setProperty('left', start.left + 'px');
      shell.style.setProperty('top', start.top + 'px');
      shell.style.setProperty('width', start.width + 'px');
      shell.style.setProperty('height', start.height + 'px');
      shell.style.setProperty('border-radius', opening ? '999px' : '28px');

      if (card) shell.appendChild(card);
      if (chip) shell.appendChild(chip);
      document.body.appendChild(shell);

      mobileMorphCleanups.push(function () {
        if (shell.parentNode) shell.parentNode.removeChild(shell);
      });

      animations.push(shell.animate(
        shellGeometryKeyframes(startRect, endRect, opening ? '999px' : '28px', opening ? '28px' : '999px'),
        { duration: duration, easing: easing, fill: 'both' }
      ));

      if (card) {
        animations.push(card.animate(opening ? [
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.985)', offset: 0 },
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.985)', offset: 0.28 },
          { opacity: 1, transform: 'translate(-50%, -50%) scale(1)', offset: 0.76 },
          { opacity: 1, transform: 'translate(-50%, -50%) scale(1)', offset: 1 }
        ] : [
          { opacity: 1, transform: 'translate(-50%, -50%) scale(1)', offset: 0 },
          { opacity: 1, transform: 'translate(-50%, -50%) scale(1)', offset: 0.18 },
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.985)', offset: 0.66 },
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.985)', offset: 1 }
        ], { duration: duration, easing: 'ease-out', fill: 'both' }));
      }

      if (chip) {
        animations.push(chip.animate(opening ? [
          { opacity: 1, transform: 'translate(-50%, -50%) scale(1)', offset: 0 },
          { opacity: 0.92, transform: 'translate(-50%, -50%) scale(0.98)', offset: 0.22 },
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.86)', offset: 0.52 },
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.86)', offset: 1 }
        ] : [
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.86)', offset: 0 },
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.86)', offset: 0.46 },
          { opacity: 1, transform: 'translate(-50%, -50%) scale(1)', offset: 1 }
        ], { duration: duration, easing: 'ease-out', fill: 'both' }));
      }

      return animations;
    }

    function mobileNavArrowGeometry(button, buttonRect) {
      var arrow = button ? button.querySelector('svg') : null;
      if (!arrow || !buttonRect) {
        return {
          element: arrow,
          offsetX: 0,
          offsetY: 0,
          width: 20,
          height: 20
        };
      }

      var arrowRect = arrow.getBoundingClientRect();
      if (!arrowRect.width || !arrowRect.height) {
        return {
          element: arrow,
          offsetX: 0,
          offsetY: 0,
          width: 20,
          height: 20
        };
      }

      return {
        element: arrow,
        // The real SVG is deliberately offset into the visible half of each
        // edge button by its left/right margin. The morph clone used to stay
        // centred in the circle, then jump to this offset during hand-off.
        // Measure the rendered icon instead of duplicating that CSS geometry.
        offsetX: (arrowRect.left + (arrowRect.width / 2)) - (buttonRect.left + (buttonRect.width / 2)),
        offsetY: (arrowRect.top + (arrowRect.height / 2)) - (buttonRect.top + (buttonRect.height / 2)),
        width: arrowRect.width,
        height: arrowRect.height
      };
    }

    function mobileNavArrowPosition(offset) {
      if (Math.abs(offset) < 0.01) return '50%';
      return 'calc(50% + ' + offset.toFixed(3) + 'px)';
    }

    function captureMobileNavControls() {
      return [
        { direction: -1, button: previousButton },
        { direction: 1, button: nextButton }
      ].map(function (snapshot) {
        if (!snapshot.button) return null;
        var rect = snapshot.button.getBoundingClientRect();
        if (!rect.width || !rect.height) return null;
        snapshot.rect = {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height
        };
        snapshot.arrowGeometry = mobileNavArrowGeometry(snapshot.button, rect);
        return snapshot;
      }).filter(Boolean);
    }

    function appendMobileNavToChipMorphAnimations(snapshots, duration, easing) {
      if (!snapshots || !snapshots.length) return;
      var usedTargets = [];

      snapshots.forEach(function (snapshot) {
        var targetIndex = (activeMobileIndex + snapshot.direction + items.length) % items.length;
        var targetItem = items[targetIndex];
        if (!targetItem || usedTargets.indexOf(targetItem) !== -1) return;
        usedTargets.push(targetItem);

        var targetRect = targetItem.getBoundingClientRect();
        if (!targetRect.width || !targetRect.height) return;

        var trigger = mobileTriggerFor(targetItem);
        var chipContent = cloneMobileChipContent(targetItem, targetRect.width, targetRect.height);
        var arrowGeometry = snapshot.arrowGeometry || mobileNavArrowGeometry(snapshot.button, snapshot.rect);
        var arrow = arrowGeometry.element;
        var arrowClone = arrow ? arrow.cloneNode(true) : null;
        var start = pageCoordinates(snapshot.rect);
        var ghost = document.createElement('div');

        targetItem.style.setProperty('transition', 'none');
        targetItem.style.setProperty('opacity', '0');
        targetItem.style.setProperty('visibility', 'visible');

        snapshot.button.style.setProperty('transition', 'none');
        snapshot.button.style.setProperty('opacity', '0');
        snapshot.button.style.setProperty('pointer-events', 'none');

        ghost.className = 'cd-home-specs__mobile-adjacent-morph cd-home-specs__mobile-adjacent-morph--reverse';
        ghost.setAttribute('aria-hidden', 'true');
        ghost.style.setProperty('left', start.left + 'px');
        ghost.style.setProperty('top', start.top + 'px');
        ghost.style.setProperty('width', start.width + 'px');
        ghost.style.setProperty('height', start.height + 'px');
        ghost.style.setProperty('border-radius', '50%');

        if (chipContent) {
          chipContent.classList.add('cd-home-specs__mobile-adjacent-chip-content--reverse');
          ghost.appendChild(chipContent);
        }
        if (arrowClone) {
          arrowClone.classList.add('cd-home-specs__mobile-adjacent-arrow');
          arrowClone.style.setProperty('left', mobileNavArrowPosition(arrowGeometry.offsetX));
          arrowClone.style.setProperty('top', mobileNavArrowPosition(arrowGeometry.offsetY));
          arrowClone.style.setProperty('width', arrowGeometry.width + 'px');
          arrowClone.style.setProperty('height', arrowGeometry.height + 'px');
          arrowClone.style.setProperty('opacity', '1');
          arrowClone.style.setProperty('transform', 'translate(-50%, -50%) scale(1)');
          ghost.appendChild(arrowClone);
        }
        document.body.appendChild(ghost);

        mobileMorphCleanups.push(function () {
          targetItem.style.setProperty('opacity', '1');
          if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
          window.requestAnimationFrame(function () {
            removeInlineProperties(targetItem, ['transition', 'opacity', 'visibility']);
            removeInlineProperties(snapshot.button, ['transition', 'opacity', 'pointer-events']);
          });
        });

        mobileAnimations.push(ghost.animate(
          shellGeometryKeyframes(snapshot.rect, targetRect, '50%', '999px'),
          { duration: duration, easing: easing, fill: 'both' }
        ));

        if (chipContent) {
          mobileAnimations.push(chipContent.animate([
            { opacity: 0, transform: 'translate(-50%, -50%) scale(0.84)', offset: 0 },
            { opacity: 0, transform: 'translate(-50%, -50%) scale(0.84)', offset: 0.42 },
            { opacity: 1, transform: 'translate(-50%, -50%) scale(1)', offset: 1 }
          ], { duration: duration, easing: 'ease-out', fill: 'both' }));
        }

        if (arrowClone) {
          mobileAnimations.push(arrowClone.animate([
            {
              left: mobileNavArrowPosition(arrowGeometry.offsetX),
              top: mobileNavArrowPosition(arrowGeometry.offsetY),
              opacity: 1,
              transform: 'translate(-50%, -50%) scale(1)',
              offset: 0
            },
            {
              left: mobileNavArrowPosition(arrowGeometry.offsetX * 0.42),
              top: mobileNavArrowPosition(arrowGeometry.offsetY * 0.42),
              opacity: 0,
              transform: 'translate(-50%, -50%) scale(0.68)',
              offset: 0.58
            },
            {
              left: '50%',
              top: '50%',
              opacity: 0,
              transform: 'translate(-50%, -50%) scale(0.68)',
              offset: 1
            }
          ], { duration: duration, easing: 'ease-out', fill: 'both' }));
        }
      });
    }


    function captureAdjacentMobileChips(index) {
      if (!mobileQuery.matches || !section.classList.contains('is-mobile-copy-closed') || items.length < 2) return [];

      return [-1, 1].map(function (direction) {
        var adjacentIndex = (index + direction + items.length) % items.length;
        var adjacentItem = items[adjacentIndex];
        var adjacentTrigger = mobileTriggerFor(adjacentItem);
        var rect = adjacentItem ? adjacentItem.getBoundingClientRect() : null;

        if (!adjacentItem || !adjacentTrigger || !rect || !rect.width || !rect.height) return null;
        return {
          direction: direction,
          item: adjacentItem,
          trigger: adjacentTrigger,
          rect: {
            left: rect.left,
            top: rect.top,
            width: rect.width,
            height: rect.height
          }
        };
      }).filter(Boolean);
    }

    function appendAdjacentChipMorphAnimations(snapshots, duration, easing) {
      if (!snapshots || !snapshots.length) return;

      var pageLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;
      var pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      snapshots.forEach(function (snapshot) {
        var targetButton = snapshot.direction < 0 ? previousButton : nextButton;
        if (!targetButton) return;

        // Resolve the button's final, full-size geometry before measuring it.
        // Without this, getBoundingClientRect can catch the old hidden scale
        // while the closed rail class is being removed.
        targetButton.style.setProperty('transition', 'none');
        targetButton.style.setProperty('opacity', '0');
        targetButton.style.setProperty('transform', 'scale(1)');
        targetButton.style.setProperty('visibility', 'visible');
        targetButton.style.setProperty('pointer-events', 'auto');

        var targetRect = targetButton.getBoundingClientRect();
        if (!targetRect.width || !targetRect.height) {
          removeInlineProperties(targetButton, ['transition', 'opacity', 'transform', 'visibility', 'pointer-events']);
          return;
        }

        var ghost = document.createElement('div');
        var chipContent = document.createElement('div');
        var arrowGeometry = mobileNavArrowGeometry(targetButton, targetRect);
        var arrow = arrowGeometry.element;
        var arrowClone = arrow ? arrow.cloneNode(true) : null;
        var startLeft = snapshot.rect.left + pageLeft;
        var startTop = snapshot.rect.top + pageTop;
        var targetLeft = targetRect.left + pageLeft;
        var targetTop = targetRect.top + pageTop;
        var triggerChildren = Array.prototype.slice.call(snapshot.trigger.children);

        ghost.className = 'cd-home-specs__mobile-adjacent-morph' + (snapshot.direction < 0 ? ' cd-home-specs__mobile-adjacent-morph--prev' : ' cd-home-specs__mobile-adjacent-morph--next');
        ghost.setAttribute('aria-hidden', 'true');
        ghost.style.setProperty('left', startLeft + 'px');
        ghost.style.setProperty('top', startTop + 'px');
        ghost.style.setProperty('width', snapshot.rect.width + 'px');
        ghost.style.setProperty('height', snapshot.rect.height + 'px');

        chipContent.className = 'cd-home-specs__mobile-adjacent-chip-content';
        triggerChildren.forEach(function (child) {
          chipContent.appendChild(child.cloneNode(true));
        });
        ghost.appendChild(chipContent);

        if (arrowClone) {
          arrowClone.classList.add('cd-home-specs__mobile-adjacent-arrow');
          arrowClone.style.setProperty('width', arrowGeometry.width + 'px');
          arrowClone.style.setProperty('height', arrowGeometry.height + 'px');
          ghost.appendChild(arrowClone);
        }

        document.body.appendChild(ghost);

        // The real controls stay in their final hit areas, but remain visually
        // transparent until the adjacent chips have completed their morph.
        var cleaned = false;
        mobileMorphCleanups.push(function () {
          if (cleaned) return;
          cleaned = true;

          // Reveal the real button before removing the final ghost frame so no
          // blank frame appears between the chip and navigation control.
          targetButton.style.setProperty('opacity', '1');
          if (ghost.parentNode) ghost.parentNode.removeChild(ghost);

          window.requestAnimationFrame(function () {
            removeInlineProperties(targetButton, ['transition', 'opacity', 'transform', 'visibility', 'pointer-events']);
          });
        });

        if (typeof ghost.animate === 'function') {
          mobileAnimations.push(ghost.animate(
            shellGeometryKeyframes(snapshot.rect, targetRect, '999px', '50%'),
            { duration: duration, easing: easing, fill: 'both' }
          ));
        }

        if (typeof chipContent.animate === 'function') {
          mobileAnimations.push(chipContent.animate([
            { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1)', offset: 0 },
            { opacity: 0.96, transform: 'translate3d(0, 0, 0) scale(0.98)', offset: 0.32 },
            { opacity: 0, transform: 'translate3d(' + (snapshot.direction < 0 ? '-5px' : '5px') + ', 0, 0) scale(0.86)', offset: 0.72 },
            { opacity: 0, transform: 'translate3d(' + (snapshot.direction < 0 ? '-5px' : '5px') + ', 0, 0) scale(0.86)', offset: 1 }
          ], {
            duration: duration,
            easing: 'ease-out',
            fill: 'both'
          }));
        }

        if (arrowClone && typeof arrowClone.animate === 'function') {
          mobileAnimations.push(arrowClone.animate([
            {
              left: '50%',
              top: '50%',
              opacity: 0,
              transform: 'translate(-50%, -50%) scale(0.48)',
              offset: 0
            },
            {
              left: mobileNavArrowPosition(arrowGeometry.offsetX * 0.18),
              top: mobileNavArrowPosition(arrowGeometry.offsetY * 0.18),
              opacity: 0,
              transform: 'translate(-50%, -50%) scale(0.48)',
              offset: 0.42
            },
            {
              left: mobileNavArrowPosition(arrowGeometry.offsetX * 0.78),
              top: mobileNavArrowPosition(arrowGeometry.offsetY * 0.78),
              opacity: 0.82,
              transform: 'translate(-50%, -50%) scale(0.92)',
              offset: 0.78
            },
            {
              left: mobileNavArrowPosition(arrowGeometry.offsetX),
              top: mobileNavArrowPosition(arrowGeometry.offsetY),
              opacity: 1,
              transform: 'translate(-50%, -50%) scale(1)',
              offset: 0.9
            },
            {
              left: mobileNavArrowPosition(arrowGeometry.offsetX),
              top: mobileNavArrowPosition(arrowGeometry.offsetY),
              opacity: 1,
              transform: 'translate(-50%, -50%) scale(1)',
              offset: 1
            }
          ], {
            duration: duration,
            easing: easing,
            fill: 'both'
          }));
        }
      });
    }

    function animateMobileMorph(item, fromRect, opening, adjacentSnapshots) {
      if (!mobileQuery.matches || mobileTransitionLocked || !item || !fromRect || reducedMotionQuery.matches || typeof item.animate !== 'function') return false;

      cancelMobileAnimations();
      var token = ++mobileMorphToken;
      var toRect = item.getBoundingClientRect();
      if (!toRect.width || !toRect.height || !fromRect.width || !fromRect.height) return false;

      var duration = 620;
      var easing = 'cubic-bezier(0.16, 1, 0.3, 1)';
      var finalized = false;

      section.classList.add('is-mobile-morphing');
      mobileTransitionLocked = true;
      mobileMorphItem = item;

      // Keep the real card in its exact final layout and let a visual shell do
      // the morphing. This removes the last-frame reflow that previously made
      // the card click into place after the animation completed.
      item.style.setProperty('transition', 'none');
      item.style.setProperty('opacity', '0');
      item.style.setProperty('visibility', 'visible');
      item.style.setProperty('pointer-events', 'none');

      mobileAnimations = createChipCardMorph(item, fromRect, toRect, opening, duration, easing);
      if (opening) appendAdjacentChipMorphAnimations(adjacentSnapshots, duration, easing);

      function finalizeMorph() {
        if (finalized || token !== mobileMorphToken) return;
        finalized = true;

        // Reveal the real final card beneath an identical completed ghost, then
        // remove the ghost on the following paint. There is no empty or snapping
        // frame between the animated and settled states.
        item.style.setProperty('opacity', '1');
        item.style.setProperty('visibility', 'visible');

        window.requestAnimationFrame(function () {
          cancelMobileAnimations();
          window.requestAnimationFrame(function () {
            removeInlineProperties(item, ['transition', 'opacity', 'visibility', 'pointer-events']);
            unlockMobileTransition();
          });
        });
      }

      waitForAnimations(mobileAnimations.slice(), finalizeMorph);
      return true;
    }

    function animateMobileCloseToRail(item, fromRect, navSnapshots) {
      if (!mobileQuery.matches || mobileTransitionLocked || !item || !fromRect || reducedMotionQuery.matches || typeof item.animate !== 'function') return false;

      var chipRect = item.getBoundingClientRect();
      if (!chipRect.width || !chipRect.height || !fromRect.width || !fromRect.height) return false;

      cancelMobileAnimations();
      mobileTransitionLocked = true;
      var token = ++mobileMorphToken;
      var duration = 640;
      var easing = 'cubic-bezier(0.16, 1, 0.3, 1)';
      var finalized = false;

      section.classList.add('is-mobile-morphing');
      mobileMorphItem = item;

      // Keep the completed rail out of view while the card and navigation
      // controls travel back into it. Showing the real rail during this motion
      // causes the chips to pop in underneath the ghosts and creates the clicky,
      // doubled frame seen at the end of the close animation.
      var railCleanupDone = false;
      if (list) {
        list.style.setProperty('transition', 'none');
        list.style.setProperty('opacity', '0');
        list.style.setProperty('pointer-events', 'none');
        mobileMorphCleanups.push(function () {
          if (railCleanupDone) return;
          railCleanupDone = true;
          removeInlineProperties(list, ['transition', 'opacity', 'pointer-events']);
        });
      }

      // The actual chip stays in the rail at its final geometry. A cloned shell
      // runs the card-to-chip motion above it, which makes closing the exact
      // visual reverse of opening and prevents the old DOM reparenting jump.
      item.style.setProperty('transition', 'none');
      item.style.setProperty('opacity', '0');
      item.style.setProperty('visibility', 'visible');
      item.style.setProperty('pointer-events', 'none');

      mobileAnimations = createChipCardMorph(item, fromRect, chipRect, false, duration, easing);
      appendMobileNavToChipMorphAnimations(navSnapshots, duration, easing);

      function finalizeClose() {
        if (finalized || token !== mobileMorphToken) return;
        finalized = true;

        item.style.setProperty('opacity', '1');
        item.style.setProperty('visibility', 'visible');
        // Reveal the final rail underneath the completed ghost layers before
        // those layers are removed. The hand-off now happens on one paint rather
        // than exposing an empty or partially populated rail.
        if (list) list.style.setProperty('opacity', '1');

        window.requestAnimationFrame(function () {
          cancelMobileAnimations();
          window.requestAnimationFrame(function () {
            removeInlineProperties(item, ['transition', 'opacity', 'visibility', 'pointer-events']);
            unlockMobileTransition();
          });
        });
      }

      waitForAnimations(mobileAnimations.slice(), finalizeClose);
      return true;
    }

    function animateNavButtonToCard(delta, button, isQueuedNavigation) {
      if (!mobileQuery.matches || mobileTransitionLocked || !button || reducedMotionQuery.matches || typeof button.animate !== 'function') return false;

      resetMobileStageScroll();
      var targetIndex = (activeMobileIndex + delta + items.length) % items.length;
      var previousIndex = activeMobileIndex;
      var targetItem = items[targetIndex];
      var targetCard = mobileCardFor(targetItem);
      var previousItem = activeMobileItem();
      var fromRect = button.getBoundingClientRect();
      var previousRect = previousItem ? previousItem.getBoundingClientRect() : null;
      var exitButton = delta > 0 ? previousButton : nextButton;
      var exitRect = exitButton ? exitButton.getBoundingClientRect() : null;
      var animationHost = stage;
      var hostRect = animationHost ? animationHost.getBoundingClientRect() : null;
      if (!targetItem || !targetCard || !animationHost || !hostRect || !fromRect.width || !fromRect.height) return false;

      // Keep every moving layer inside the fixed-size stage instead of appending
      // it to <body>. Body-level ghosts extended beyond the viewport at the
      // half-visible arrow positions and briefly created page overflow, changing
      // the layout viewport width by a scrollbar. That was the real source of the
      // final 20px button "click" after each slide settled.
      var fromLeft = fromRect.left - hostRect.left;
      var fromTop = fromRect.top - hostRect.top;
      var previousLeft = previousRect ? previousRect.left - hostRect.left : 0;
      var previousTop = previousRect ? previousRect.top - hostRect.top : 0;
      var exitLeft = exitRect ? exitRect.left - hostRect.left : 0;
      var exitTop = exitRect ? exitRect.top - hostRect.top : 0;

      cancelMobileAnimations();
      mobileTransitionLocked = true;
      var token = ++mobileMorphToken;
      var duration = isQueuedNavigation ? 390 : 620;
      var easing = 'cubic-bezier(0.22, 1, 0.36, 1)';
      var previousGhost = null;
      var replenishingButtonGhost = null;
      var destinationButtonGhost = null;
      var placeholder = document.createElement('li');
      var originalParent = targetItem.parentNode;

      if (previousItem && previousRect && previousRect.width && previousRect.height) {
        previousGhost = previousItem.cloneNode(true);
        previousGhost.removeAttribute('id');
        previousGhost.setAttribute('aria-hidden', 'true');
        // Document coordinates keep the outgoing card attached to the section
        // when the page is scrolled during a swipe.
        previousGhost.style.cssText = 'position:absolute;left:' + previousLeft + 'px;top:' + previousTop + 'px;width:' + previousRect.width + 'px;height:' + previousRect.height + 'px;min-height:0;display:block;margin:0;z-index:2147482998;border-radius:28px;overflow:hidden;pointer-events:none;background:rgba(31,29,31,.96);';
        animationHost.appendChild(previousGhost);
      }

      // Activate and measure the real incoming card first. The real card itself
      // becomes the moving layer, so its complete text and swatches are already
      // rendered inside it throughout the swipe—there is no content swap or
      // opacity reveal when it reaches the centre.
      setMobileActive(targetIndex, false, false);
      var toRect = targetItem.getBoundingClientRect();
      var toLeft = toRect.left - hostRect.left;
      var toTop = toRect.top - hostRect.top;
      if (!toRect.width || !toRect.height) {
        if (previousGhost) previousGhost.remove();
        setMobileActive(previousIndex, true, false);
        unlockMobileTransition();
        return false;
      }

      placeholder.className = 'cd-home-specs__mobile-morph-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.style.cssText = 'width:' + toRect.width + 'px;height:' + toRect.height + 'px;min-height:' + toRect.height + 'px;display:block;visibility:hidden;list-style:none;';
      originalParent.replaceChild(placeholder, targetItem);
      animationHost.appendChild(targetItem);

      // Keep both real controls in their final hit areas throughout the morph.
      // The clicked control becomes an invisible, immediately reusable hit target,
      // while a visual clone travels in from beyond the edge to replenish it. This
      // removes the empty slot and allows another click before the card settles.
      var buttonStyles = window.getComputedStyle(button);
      replenishingButtonGhost = button.cloneNode(true);
      replenishingButtonGhost.removeAttribute('id');
      replenishingButtonGhost.removeAttribute('data-cd-specs-mobile-prev');
      replenishingButtonGhost.removeAttribute('data-cd-specs-mobile-next');
      replenishingButtonGhost.setAttribute('aria-hidden', 'true');
      replenishingButtonGhost.setAttribute('tabindex', '-1');
      replenishingButtonGhost.style.cssText = 'position:absolute;left:' + fromLeft + 'px;right:auto;top:' + fromTop + 'px;bottom:auto;width:' + fromRect.width + 'px;height:' + fromRect.height + 'px;display:flex;align-items:center;justify-content:center;margin:0;padding:0;border:0;border-radius:50%;background:' + buttonStyles.backgroundColor + ';color:' + buttonStyles.color + ';opacity:0;z-index:2147482999;pointer-events:none;box-sizing:border-box;transition:none;outline:0;';
      animationHost.appendChild(replenishingButtonGhost);
      button.style.setProperty('transition', 'none');
      button.style.setProperty('opacity', '0');
      button.style.setProperty('transform', 'scale(1)');
      button.style.setProperty('visibility', 'visible');
      button.style.setProperty('pointer-events', 'auto');
      button.classList.add('is-mobile-nav-replenishing');

      // The outgoing card collapses into the opposite control. Render an exact
      // clone of that destination control above the collapsing card and crossfade
      // to it before the geometry animation finishes. Previously the real arrow
      // was only exposed after the card ghost was removed, which caused the
      // single-frame "click" at the end of every next/previous transition.
      if (exitButton && exitRect && exitRect.width && exitRect.height) {
        var exitButtonStyles = window.getComputedStyle(exitButton);
        destinationButtonGhost = exitButton.cloneNode(true);
        destinationButtonGhost.removeAttribute('id');
        destinationButtonGhost.removeAttribute('data-cd-specs-mobile-prev');
        destinationButtonGhost.removeAttribute('data-cd-specs-mobile-next');
        destinationButtonGhost.setAttribute('aria-hidden', 'true');
        destinationButtonGhost.setAttribute('tabindex', '-1');
        destinationButtonGhost.style.cssText = 'position:absolute;left:' + exitLeft + 'px;right:auto;top:' + exitTop + 'px;bottom:auto;width:' + exitRect.width + 'px;height:' + exitRect.height + 'px;display:flex;align-items:center;justify-content:center;margin:0;padding:0;border:0;border-radius:50%;background:' + exitButtonStyles.backgroundColor + ';color:' + exitButtonStyles.color + ';opacity:0;transform:translate3d(0,0,0) scale(.72);transform-origin:center center;z-index:2147483001;pointer-events:none;box-sizing:border-box;transition:none;outline:0;backface-visibility:hidden;-webkit-backface-visibility:hidden;will-change:opacity,transform;';
        animationHost.appendChild(destinationButtonGhost);

        exitButton.style.setProperty('transition', 'none');
        exitButton.style.setProperty('opacity', '0');
        exitButton.style.setProperty('transform', 'scale(1)');
        exitButton.style.setProperty('visibility', 'visible');
        exitButton.style.setProperty('pointer-events', 'auto');
        exitButton.classList.add('is-mobile-nav-replenishing');
      }

      targetItem.classList.add('is-mobile-overlay-morph');
      targetItem.style.setProperty('position', 'absolute');
      targetItem.style.setProperty('left', fromLeft + 'px');
      targetItem.style.setProperty('top', fromTop + 'px');
      targetItem.style.setProperty('width', fromRect.width + 'px');
      targetItem.style.setProperty('height', fromRect.height + 'px');
      targetItem.style.setProperty('min-height', '0');
      targetItem.style.setProperty('max-width', 'none');
      targetItem.style.setProperty('display', 'block');
      targetItem.style.setProperty('margin', '0');
      targetItem.style.setProperty('z-index', '2147483000');
      targetItem.style.setProperty('border-radius', '50%');
      targetItem.style.setProperty('overflow', 'hidden');
      targetItem.style.setProperty('pointer-events', 'none');
      targetItem.style.setProperty('box-sizing', 'border-box');

      // Keep the copy at its final dimensions while the shell grows around it.
      // This avoids text reflow during the swipe and makes the finished frame
      // identical to the frame immediately before it.
      targetCard.style.setProperty('position', 'absolute');
      targetCard.style.setProperty('left', '50%');
      targetCard.style.setProperty('top', '50%');
      targetCard.style.setProperty('width', toRect.width + 'px');
      targetCard.style.setProperty('min-height', toRect.height + 'px');
      targetCard.style.setProperty('opacity', '1');
      targetCard.style.setProperty('visibility', 'visible');
      targetCard.style.setProperty('transform', 'translate(-50%, -50%)');
      targetCard.style.setProperty('transition', 'none');
      targetCard.style.setProperty('pointer-events', 'none');
      targetCard.style.setProperty('box-sizing', 'border-box');

      section.classList.add('is-mobile-morphing');
      mobileMorphItem = targetItem;
      changeItemBackground(targetItem, false, delta);

      var animations = [];
      if (replenishingButtonGhost && typeof replenishingButtonGhost.animate === 'function') {
        var replenishDistance = Math.max(34, fromRect.width * 0.95);
        var replenishDirection = delta > 0 ? 1 : -1;
        animations.push(replenishingButtonGhost.animate([
          {
            opacity: 0,
            transform: 'translate3d(' + (replenishDirection * replenishDistance) + 'px, 0, 0) scale(0.58)',
            offset: 0
          },
          {
            opacity: 0.72,
            transform: 'translate3d(' + (replenishDirection * replenishDistance * 0.18) + 'px, 0, 0) scale(0.9)',
            offset: 0.62
          },
          {
            opacity: 1,
            transform: 'translate3d(0, 0, 0) scale(1)',
            offset: 1
          }
        ], {
          duration: isQueuedNavigation ? 230 : 390,
          easing: easing,
          fill: 'both'
        }));
      }

      if (destinationButtonGhost && typeof destinationButtonGhost.animate === 'function') {
        animations.push(destinationButtonGhost.animate([
          {
            opacity: 0,
            transform: 'translate3d(0, 0, 0) scale(0.72)',
            offset: 0
          },
          {
            opacity: 0,
            transform: 'translate3d(0, 0, 0) scale(0.72)',
            offset: 0.54
          },
          {
            opacity: 0.78,
            transform: 'translate3d(0, 0, 0) scale(0.94)',
            offset: 0.82
          },
          {
            opacity: 1,
            transform: 'translate3d(0, 0, 0) scale(1)',
            offset: 1
          }
        ], {
          duration: duration,
          easing: easing,
          fill: 'both'
        }));
      }

      animations.push(targetItem.animate([
        {
          left: fromLeft + 'px',
          top: fromTop + 'px',
          width: fromRect.width + 'px',
          height: fromRect.height + 'px',
          borderRadius: '50%'
        },
        {
          left: toLeft + 'px',
          top: toTop + 'px',
          width: toRect.width + 'px',
          height: toRect.height + 'px',
          borderRadius: '28px'
        }
      ], { duration: duration, easing: easing, fill: 'both' }));

      if (previousGhost) {
        if (exitRect && exitRect.width && exitRect.height) {
          animations.push(previousGhost.animate([
            {
              left: previousLeft + 'px',
              top: previousTop + 'px',
              width: previousRect.width + 'px',
              height: previousRect.height + 'px',
              borderRadius: '28px'
            },
            {
              left: exitLeft + 'px',
              top: exitTop + 'px',
              width: exitRect.width + 'px',
              height: exitRect.height + 'px',
              borderRadius: '50%'
            }
          ], { duration: duration, easing: easing, fill: 'both' }));

          // Fade the collapsing shell into the exact destination-button clone.
          // The arrow and circle are therefore already fully rendered before the
          // real button is handed back, rather than popping in after completion.
          animations.push(previousGhost.animate([
            { opacity: 1, offset: 0 },
            { opacity: 1, offset: 0.7 },
            { opacity: 0.38, offset: 0.88 },
            { opacity: 0, offset: 1 }
          ], { duration: duration, easing: 'ease-out', fill: 'both' }));

          var previousCopy = mobileCardFor(previousGhost);
          if (previousCopy) {
            animations.push(previousCopy.animate([
              { opacity: 1, offset: 0 },
              { opacity: 0, offset: 0.48 },
              { opacity: 0, offset: 1 }
            ], { duration: duration, easing: 'ease-out', fill: 'both' }));
          }
        } else {
          animations.push(previousGhost.animate([
            { opacity: 1, transform: 'scale(1)' },
            { opacity: 0, transform: 'scale(0.96)' }
          ], { duration: 240, easing: 'ease-out', fill: 'both' }));
        }
      }

      mobileAnimations = animations;
      var navFinished = false;

      function finalizeNavigation() {
        if (navFinished) return;
        navFinished = true;

        // Freeze the two visual button shells at their exact final frame before
        // cancelling WAAPI. Keep the real controls transparent during this phase.
        // Showing the semi-transparent ghost and real button at the same time
        // double-composited their anti-aliased edges, which created the brief grey
        // halo / "click" visible after every slide change.
        if (replenishingButtonGhost) {
          replenishingButtonGhost.style.setProperty('opacity', '1');
          replenishingButtonGhost.style.setProperty('transform', 'translate3d(0, 0, 0) scale(1)');
        }
        if (destinationButtonGhost) {
          destinationButtonGhost.style.setProperty('opacity', '1');
          destinationButtonGhost.style.setProperty('transform', 'translate3d(0, 0, 0) scale(1)');
        }
        button.style.setProperty('transition', 'none');
        button.style.setProperty('opacity', '0');
        button.style.setProperty('transform', 'scale(1)');
        button.style.setProperty('visibility', 'visible');
        if (exitButton) {
          exitButton.style.setProperty('transition', 'none');
          exitButton.style.setProperty('opacity', '0');
          exitButton.style.setProperty('transform', 'scale(1)');
          exitButton.style.setProperty('visibility', 'visible');
        }

        // Cancel the moving layers and restore the same real card into its final
        // DOM position. Since the content never changed, Safari has nothing to
        // repaint or reveal on the settling frame.
        cancelMobileAnimations();
        targetItem.classList.remove('is-mobile-overlay-morph');
        removeInlineProperties(targetCard, ['position', 'left', 'top', 'width', 'min-height', 'opacity', 'visibility', 'transform', 'transition', 'pointer-events', 'box-sizing']);
        removeInlineProperties(targetItem, ['position', 'left', 'top', 'width', 'height', 'min-height', 'max-width', 'display', 'margin', 'z-index', 'border-radius', 'overflow', 'pointer-events', 'box-sizing']);
        if (placeholder.parentNode) placeholder.parentNode.replaceChild(targetItem, placeholder);
        else if (targetItem.parentNode !== originalParent) originalParent.appendChild(targetItem);

        if (previousGhost) previousGhost.remove();

        // Swap the frozen shells for the real controls atomically on the next
        // paint. The ghosts are removed in the same JavaScript task that reveals
        // the real buttons, so there is neither a blank frame nor an overlapping
        // double-opacity frame. Keep transition:none for one additional paint so
        // the browser cannot interpolate the hand-off.
        activeMobileNavFinalize = null;
        window.requestAnimationFrame(function () {
          button.style.setProperty('opacity', '1');
          button.style.setProperty('transform', 'scale(1)');
          button.style.setProperty('visibility', 'visible');
          if (exitButton) {
            exitButton.style.setProperty('opacity', '1');
            exitButton.style.setProperty('transform', 'scale(1)');
            exitButton.style.setProperty('visibility', 'visible');
          }

          if (replenishingButtonGhost) replenishingButtonGhost.remove();
          if (destinationButtonGhost) destinationButtonGhost.remove();
          resetMobileStageScroll();

          window.requestAnimationFrame(function () {
            removeInlineProperties(button, ['opacity', 'transition', 'transform', 'visibility', 'pointer-events']);
            button.classList.remove('is-mobile-nav-replenishing');
            if (exitButton) {
              removeInlineProperties(exitButton, ['opacity', 'transition', 'transform', 'visibility', 'pointer-events']);
              exitButton.classList.remove('is-mobile-nav-replenishing');
            }
            unlockMobileTransition();
          });
        });
      }

      function accelerateNavigation() {
        animations.forEach(function (animation) {
          try {
            if (typeof animation.updatePlaybackRate === 'function') {
              animation.updatePlaybackRate(Math.max(2.25, animation.playbackRate || 1));
            } else {
              animation.playbackRate = Math.max(2.25, animation.playbackRate || 1);
            }
          } catch (error) {}
        });
      }

      activeMobileNavFinalize = accelerateNavigation;
      waitForAnimations(animations, function () {
        if (token !== mobileMorphToken) return;
        finalizeNavigation();
      });
      return true;
    }

    function openMobileItem(index, originRect, immediate) {
      if (mobileTransitionLocked && !immediate) return;
      var targetIndex = (index + items.length) % items.length;
      var item = items[targetIndex];
      if (!item) return;
      var fromRect = originRect || item.getBoundingClientRect();
      var adjacentSnapshots = immediate ? [] : captureAdjacentMobileChips(targetIndex);

      setMobileActive(targetIndex, immediate, false);
      section.classList.remove('is-mobile-copy-closed');
      syncMobileChrome(true);
      changeItemBackground(item, immediate);

      if (!immediate) animateMobileMorph(item, fromRect, true, adjacentSnapshots);
    }

    function closeMobileItem(immediate) {
      if (mobileTransitionLocked && !immediate) return;
      var item = activeMobileItem();
      if (!item) return;
      var fromRect = item.getBoundingClientRect();
      var navSnapshots = immediate ? [] : captureMobileNavControls();

      section.classList.add('is-mobile-copy-closed');
      syncMobileChrome(false);
      centerRailItem(item);
      restoreInitialBackground(immediate);

      if (!immediate) animateMobileCloseToRail(item, fromRect, navSnapshots);
    }

    function navigateMobile(delta, originButton, isQueuedNavigation) {
      if (section.classList.contains('is-mobile-copy-closed')) return;

      resetMobileStageScroll();
      window.requestAnimationFrame(resetMobileStageScroll);

      if (mobileTransitionLocked) {
        // Keep every rapid tap, but do not hard-cut the current morph to its end.
        // The active motion is accelerated and the queued direction starts as soon
        // as it settles, preserving quick navigation without the clicky jump.
        pendingMobileNavigation += delta;
        pendingMobileNavigation = Math.max(-items.length, Math.min(items.length, pendingMobileNavigation));
        if (activeMobileNavFinalize) activeMobileNavFinalize();
        return;
      }

      if (!animateNavButtonToCard(delta, originButton, isQueuedNavigation)) {
        setMobileActive(activeMobileIndex + delta, false, true, delta);
        flushPendingMobileNavigation();
      }
    }

    function initialResponsiveImageUrl() {
      if (mainImage) {
        return (mainImage.currentSrc || mainImage.getAttribute('src') || '').trim();
      }
      return '';
    }

    function backgroundValue(url) {
      return 'url(' + JSON.stringify(url) + ')';
    }

    function ensureImageLayers(seedUrl) {
      if (!media) return [];
      if (imageLayers.length === 2) return imageLayers;

      imageLayers = Array.prototype.slice.call(media.querySelectorAll('[data-cd-specs-media-layer]'));
      while (imageLayers.length < 2) {
        var layer = document.createElement('div');
        layer.className = 'cd-home-specs__media-layer';
        layer.setAttribute('data-cd-specs-media-layer', '');
        media.insertBefore(layer, media.firstChild);
        imageLayers.push(layer);
      }

      currentImageLayer = imageLayers[0];
      currentImageLayer.classList.add('is-current');
      if (seedUrl) {
        currentImageLayer.style.backgroundImage = backgroundValue(seedUrl);
        currentImageUrl = seedUrl;
      }
      media.classList.add('has-dynamic-image');
      if (placeholder) placeholder.style.display = 'none';
      return imageLayers;
    }

    function resetImageLayer(layer, keepImage) {
      if (!layer) return;
      layer.classList.remove('is-current');
      layer.style.removeProperty('opacity');
      layer.style.removeProperty('transform');
      layer.style.removeProperty('z-index');
      if (!keepImage) layer.style.removeProperty('background-image');
    }

    function cancelImageAnimations() {
      imageAnimations.forEach(function (animation) {
        try { animation.cancel(); } catch (error) {}
      });
      imageAnimations = [];
    }

    function finishActiveImageTransition() {
      if (typeof activeImageFinalize === 'function') activeImageFinalize();
    }

    function commitBackgroundImage(url) {
      if (!media || !url) return null;
      finishActiveImageTransition();
      ensureImageLayers(currentImageUrl || initialResponsiveImageUrl());

      var layer = currentImageLayer || imageLayers[0];
      imageLayers.forEach(function (candidate) {
        resetImageLayer(candidate, candidate === layer);
      });
      layer.style.backgroundImage = backgroundValue(url);
      layer.classList.add('is-current');
      currentImageLayer = layer;
      currentImageUrl = url;
      requestedImageUrl = url;
      section.dataset.activeSpecImage = url;
      media.classList.add('has-dynamic-image');
      section.classList.remove('is-image-changing');
      if (placeholder) placeholder.style.display = 'none';
      return layer;
    }

    function animateBackgroundImage(url, direction, token, onComplete) {
      if (!media || !url || token !== imageSwapToken) return;
      finishActiveImageTransition();
      ensureImageLayers(currentImageUrl || initialResponsiveImageUrl());

      var outgoing = currentImageLayer || imageLayers[0];
      var incoming = imageLayers[0] === outgoing ? imageLayers[1] : imageLayers[0];
      var normalizedDirection = direction < 0 ? -1 : direction > 0 ? 1 : 0;
      var travel = mobileQuery.matches ? 34 : 26;
      var duration = mobileQuery.matches ? 680 : 720;
      var easing = 'cubic-bezier(0.32, 0.72, 0, 1)';
      var incomingOffset = normalizedDirection * travel;
      var outgoingOffset = normalizedDirection * -travel;
      var incomingStartScale = mobileQuery.matches ? 0.88 : 0.92;
      var incomingOvershootScale = mobileQuery.matches ? 1.075 : 1.055;
      var outgoingEndScale = mobileQuery.matches ? 1.13 : 1.09;
      var finalized = false;

      resetImageLayer(incoming, false);
      incoming.style.backgroundImage = backgroundValue(url);
      incoming.style.zIndex = '2';
      outgoing.style.zIndex = '1';
      section.classList.add('is-image-changing');
      media.classList.add('has-dynamic-image');

      if (!normalizedDirection) {
        incomingOffset = 0;
        outgoingOffset = 0;
        duration = 420;
      }

      // Combine the horizontal movement with a pronounced depth pass. The
      // outgoing image moves toward the viewer as it exits, while the incoming
      // image grows from farther back, eases slightly past its resting scale,
      // and then settles. This mirrors the layered Apple-style transition rather
      // than reading as a simple left/right wipe.
      var outgoingFrames = normalizedDirection ? [
        { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1.005)', offset: 0 },
        { opacity: 0.42, transform: 'translate3d(' + (outgoingOffset * 0.58) + '%, 0, 0) scale(' + (1 + ((outgoingEndScale - 1) * 0.55)) + ')', offset: 0.58 },
        { opacity: 0, transform: 'translate3d(' + outgoingOffset + '%, 0, 0) scale(' + outgoingEndScale + ')', offset: 1 }
      ] : [
        { opacity: 1, transform: 'scale(1.005)', offset: 0 },
        { opacity: 0.34, transform: 'scale(' + (1 + ((outgoingEndScale - 1) * 0.58)) + ')', offset: 0.62 },
        { opacity: 0, transform: 'scale(' + outgoingEndScale + ')', offset: 1 }
      ];
      var incomingFrames = normalizedDirection ? [
        { opacity: 0, transform: 'translate3d(' + incomingOffset + '%, 0, 0) scale(' + incomingStartScale + ')', offset: 0 },
        { opacity: 0.18, transform: 'translate3d(' + (incomingOffset * 0.7) + '%, 0, 0) scale(' + (incomingStartScale + ((1 - incomingStartScale) * 0.42)) + ')', offset: 0.24 },
        { opacity: 0.94, transform: 'translate3d(' + (incomingOffset * 0.1) + '%, 0, 0) scale(' + incomingOvershootScale + ')', offset: 0.76 },
        { opacity: 1, transform: 'translate3d(0, 0, 0) scale(1.005)', offset: 1 }
      ] : [
        { opacity: 0, transform: 'scale(' + incomingStartScale + ')', offset: 0 },
        { opacity: 0.92, transform: 'scale(' + incomingOvershootScale + ')', offset: 0.78 },
        { opacity: 1, transform: 'scale(1.005)', offset: 1 }
      ];

      function finalize() {
        if (finalized) return;
        finalized = true;
        cancelImageAnimations();
        resetImageLayer(outgoing, false);
        resetImageLayer(incoming, true);
        incoming.classList.add('is-current');
        currentImageLayer = incoming;
        currentImageUrl = url;
        requestedImageUrl = url;
        section.dataset.activeSpecImage = url;
        section.classList.remove('is-image-changing');
        activeImageFinalize = null;
        if (typeof onComplete === 'function') onComplete();
      }

      activeImageFinalize = finalize;

      if (typeof incoming.animate !== 'function' || typeof outgoing.animate !== 'function') {
        finalize();
        return;
      }

      imageAnimations = [
        outgoing.animate(outgoingFrames, { duration: duration, easing: easing, fill: 'both' }),
        incoming.animate(incomingFrames, { duration: duration, easing: easing, fill: 'both' })
      ];

      Promise.all(imageAnimations.map(function (animation) {
        return animation.finished.catch(function () {});
      })).then(function () {
        if (token !== imageSwapToken) return;
        finalize();
      });
    }

    function restoreInitialBackground(immediate) {
      if (!media) return;
      var url = initialResponsiveImageUrl();
      section.removeAttribute('data-active-spec-image');
      section.removeAttribute('data-active-spec-index');
      if (!url) return;

      if (immediate || reducedMotionQuery.matches) {
        var token = ++imageSwapToken;
        requestedImageUrl = url;
        commitBackgroundImage(url);
        if (token === imageSwapToken) section.removeAttribute('data-active-spec-image');
        return;
      }

      changeBackgroundImage(url, false, 0, function () {
        section.removeAttribute('data-active-spec-image');
      });
    }

    function changeBackgroundImage(url, immediate, direction, onComplete) {
      url = (url || '').trim();
      if (!url || !media) return;
      if (requestedImageUrl === url && (currentImageUrl === url || activeImageFinalize)) return;
      finishActiveImageTransition();
      var token = ++imageSwapToken;
      requestedImageUrl = url;

      if (immediate || reducedMotionQuery.matches) {
        commitBackgroundImage(url);
        if (typeof onComplete === 'function') onComplete();
        return;
      }

      var preloader = new Image();
      var swapStarted = false;
      var beginSwap = function () {
        if (swapStarted || token !== imageSwapToken) return;
        swapStarted = true;
        animateBackgroundImage(url, direction, token, onComplete);
      };

      preloader.addEventListener('load', beginSwap, { once: true });
      preloader.addEventListener('error', function () {
        if (token !== imageSwapToken) return;
        requestedImageUrl = currentImageUrl;
        section.classList.remove('is-image-changing');
      }, { once: true });
      preloader.src = url;
      if (preloader.complete && preloader.naturalWidth) beginSwap();
    }

    function responsiveImageUrl(element, desktopDataKey, mobileDataKey) {
      if (!element) return '';
      var desktopUrl = (element.dataset[desktopDataKey] || '').trim();
      var mobileUrl = (element.dataset[mobileDataKey] || '').trim();
      return mobileQuery.matches
        ? (mobileUrl || desktopUrl)
        : (desktopUrl || mobileUrl);
    }

    function selectedSwatchImageForItem(item) {
      if (!item || item.dataset.specHasSwatches !== 'true') return '';
      var selectedSwatch = item.querySelector('[data-cd-specs-swatch].is-selected');
      return responsiveImageUrl(selectedSwatch, 'specImage', 'specImageMobile');
    }

    function backgroundForItem(item) {
      if (!item) return '';
      return selectedSwatchImageForItem(item) || responsiveImageUrl(
        item,
        'specBackgroundImage',
        'specBackgroundImageMobile'
      );
    }

    function inferredItemDirection(item) {
      if (!item) return 1;
      var previousIndex = parseInt(section.dataset.activeSpecIndex, 10);
      var nextIndex = parseInt(item.dataset.specIndex, 10);
      if (!Number.isFinite(previousIndex) || !Number.isFinite(nextIndex) || previousIndex === nextIndex) return 1;
      return nextIndex > previousIndex ? 1 : -1;
    }

    function changeItemBackground(item, immediate, direction) {
      var url = backgroundForItem(item);
      if (!url) return;
      var resolvedDirection = typeof direction === 'number' ? direction : inferredItemDirection(item);
      section.dataset.activeSpecIndex = item.dataset.specIndex || '';
      changeBackgroundImage(url, immediate, resolvedDirection);
    }

    function selectSwatch(swatch, immediate) {
      if (!swatch) return;
      var group = swatch.dataset.specSwatchGroup;
      var colorIndex = parseInt(swatch.dataset.specColorIndex, 10) || 1;
      var previousSwatch = swatches.find(function (candidate) {
        return candidate.dataset.specSwatchGroup === group && candidate.classList.contains('is-selected');
      });
      var previousColorIndex = previousSwatch ? (parseInt(previousSwatch.dataset.specColorIndex, 10) || colorIndex) : colorIndex;

      swatches.forEach(function (candidate) {
        if (candidate.dataset.specSwatchGroup !== group) return;
        var isSelected = candidate.dataset.specColorIndex === swatch.dataset.specColorIndex;
        candidate.classList.toggle('is-selected', isSelected);
        candidate.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      var item = swatch.closest('[data-cd-specs-item]');
      if (item) changeItemBackground(item, immediate, colorIndex >= previousColorIndex ? 1 : -1);
    }

    measureChipWidths();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measureChipWidths();
      }).catch(function () {});
    }

    items.forEach(function (item, index) {
      var toggle = toggleFor(item);
      var panel = panelFor(item);
      var mobileTrigger = mobileTriggerFor(item);

      if (item.classList.contains('is-open')) {
        openItem(item, true);
      } else if (panel) {
        panel.hidden = true;
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            closeItem(item, false);
          } else {
            openItem(item, false);
          }
        });
      }

      if (mobileTrigger) {
        mobileTrigger.addEventListener('click', function (event) {
          if (!mobileQuery.matches) return;
          event.preventDefault();
          event.stopPropagation();
          openMobileItem(index, mobileTrigger.getBoundingClientRect(), false);
        });
      }

      if (panel) {
        var panelHasSwatches = !!panel.querySelector('[data-cd-specs-swatch]');
        if (!panelHasSwatches) {
          panel.setAttribute('role', 'button');
          panel.setAttribute('tabindex', '0');
          panel.setAttribute('aria-label', 'Close ' + ((toggle && toggle.textContent.trim()) || 'specification'));
        }
        panel.addEventListener('click', function (event) {
          if (event.target.closest('[data-cd-specs-swatch]')) return;
          if (!mobileQuery.matches) closeItem(item, false);
        });
        panel.addEventListener('keydown', function (event) {
          if (panelHasSwatches) return;
          if (mobileQuery.matches || (event.key !== 'Enter' && event.key !== ' ')) return;
          event.preventDefault();
          closeItem(item, false);
          if (toggle) toggle.focus();
        });
      }

      item.addEventListener('shopify:block:select', function () {
        activeMobileIndex = index;
        if (mobileQuery.matches) openMobileItem(index, null, true);
        else {
          setMobileActive(index, false);
          openItem(item, false);
        }
      });
    });

    if (!items.some(function (item) { return item.classList.contains('is-open'); })) {
      openItem(items[0], true);
    }
    setMobileActive(activeMobileIndex, true, true);

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectSwatch(swatch, false);
      });
    });

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        if (mobileQuery.matches) navigateMobile(-1, previousButton);
        else setMobileActive(activeMobileIndex - 1, false, true, -1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        if (mobileQuery.matches) navigateMobile(1, nextButton);
        else setMobileActive(activeMobileIndex + 1, false, true, 1);
      });
    }

    if (closeButton) {
      syncMobileChrome(!section.classList.contains('is-mobile-copy-closed'));
      closeButton.addEventListener('click', function () {
        if (!mobileQuery.matches) return;
        if (section.classList.contains('is-mobile-copy-closed')) {
          var item = activeMobileItem();
          openMobileItem(activeMobileIndex, item ? item.getBoundingClientRect() : null, false);
        } else {
          closeMobileItem(false);
        }
      });
    }

    if (stage) {
      function resetTouchGesture() {
        touchStartX = null;
        touchStartY = null;
        touchStartTime = 0;
        touchAxis = null;
        touchDidMove = false;
        stage.classList.remove('is-horizontal-swipe');
      }

      stage.addEventListener('touchstart', function (event) {
        if (
          !mobileQuery.matches ||
          section.classList.contains('is-mobile-copy-closed') ||
          event.touches.length !== 1
        ) {
          resetTouchGesture();
          return;
        }

        var touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartTime = Date.now();
        touchAxis = null;
        touchDidMove = false;
      }, { passive: true });

      stage.addEventListener('touchmove', function (event) {
        if (
          !mobileQuery.matches ||
          touchStartX === null ||
          touchStartY === null ||
          event.touches.length !== 1
        ) return;

        var touch = event.touches[0];
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        var absoluteX = Math.abs(deltaX);
        var absoluteY = Math.abs(deltaY);


        // Decide the gesture once, after a small dead zone. A slightly diagonal
        // horizontal swipe should stay with the carousel instead of moving the page.
        if (!touchAxis && Math.max(absoluteX, absoluteY) >= 7) {
          touchAxis = absoluteX >= absoluteY * 1.08 ? 'x' : 'y';
          if (touchAxis === 'x') stage.classList.add('is-horizontal-swipe');
        }

        if (touchAxis !== 'x') return;

        touchDidMove = true;
        event.preventDefault();
      }, { passive: false });

      stage.addEventListener('touchend', function (event) {
        if (!mobileQuery.matches || touchStartX === null || !event.changedTouches.length) {
          resetTouchGesture();
          return;
        }

        var endX = event.changedTouches[0].clientX;
        var distance = endX - touchStartX;
        var duration = Math.max(1, Date.now() - touchStartTime);
        var speed = Math.abs(distance) / duration;
        var wasHorizontalSwipe = touchAxis === 'x' && touchDidMove;
        var shouldNavigate = wasHorizontalSwipe && (Math.abs(distance) >= 42 || (Math.abs(distance) >= 24 && speed >= 0.28));

        if (wasHorizontalSwipe) suppressClickUntil = Date.now() + 350;
        resetTouchGesture();

        if (!shouldNavigate) return;
        var direction = distance < 0 ? 1 : -1;
        navigateMobile(direction, direction > 0 ? nextButton : previousButton);
      }, { passive: true });

      stage.addEventListener('touchcancel', resetTouchGesture, { passive: true });

      stage.addEventListener('click', function (event) {
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    function refreshResponsiveBackground() {
      if (!media || !media.classList.contains('has-dynamic-image')) return;
      var activeIndex = section.dataset.activeSpecIndex;
      var activeItem = items.find(function (item) {
        return (item.dataset.specIndex || '') === activeIndex;
      });
      if (activeItem) changeItemBackground(activeItem, true);
      else {
        var initialUrl = initialResponsiveImageUrl();
        if (initialUrl) changeBackgroundImage(initialUrl, true, 0);
      }
    }

    function handleResponsiveChange() {
      measureChipWidths();
      refreshResponsiveBackground();
      if (mobileQuery.matches && section.classList.contains('is-mobile-copy-closed')) {
        window.requestAnimationFrame(function () {
          centerRailItem(activeMobileItem());
        });
      }
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleResponsiveChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(handleResponsiveChange);
    }

    var resizeFrame = 0;
    window.addEventListener('resize', function () {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = 0;
        measureChipWidths();
        if (mobileQuery.matches) return;
        items.forEach(function (item) {
          var panel = panelFor(item);
          if (panel && item.classList.contains('is-open')) setExpandedHeight(item, panel);
        });
      });
    }, { passive: true });

    if (window.CDCleerHeaderTheme && typeof window.CDCleerHeaderTheme.refresh === 'function') {
      window.CDCleerHeaderTheme.refresh();
    }
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    if (scope.matches && scope.matches(SECTION_SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SECTION_SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
